import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import SignUpForm from './pages/Signup';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import StudentEngagement from './pages/StudentEngagement';
import PresentationPage from './talkTreeShared/PresentationGeneration/PresentationPage';
import ForgotPassword from './pages/Forgotpassword';
import Resources from './components/Resources';
import AuthCallback from './pages/AuthCallback';
import SignupCallback from './pages/SignupCallback';
import TermsOfService from './pages/TermsOfService';
import AuxRecord from './components/SessionStreaming/Auxrecord';
import { captureDemoFeaturesParam, recaptureDemoFeaturesOnNavigation } from './talkTreeShared/Tree/constants/constants';
import WelcomeOnboardingPage from './pages/WelcomeOnboarding';
captureDemoFeaturesParam();
if (typeof window !== 'undefined') {
  window.addEventListener('hashchange', recaptureDemoFeaturesOnNavigation);
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/signup" element={<SignUpForm />} />
          <Route path="/signup/callback" element={<SignupCallback />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/StudentEngagement" element={<StudentEngagement />} />
          <Route path="/Presentation" element={<PresentationPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/Resources" element={<Resources />} />
          <Route path="/" element={<Login />} />
          <Route path="/sessionStream" element={<AuxRecord />} />
          <Route path="/join" element={<AuxRecord />} />
          <Route path="/WelcomeOnboarding" element={<WelcomeOnboardingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;